var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-logo-container bg-light",class:{'collapse':_vm.collapse}},[_c('transition',{attrs:{"name":"sidebarLogoFade"}},[_c('router-link',{key:"expand",staticClass:"sidebar-logo-link",attrs:{"to":"/home"}},[_c('img',{staticClass:"sidebar-logo",attrs:{"src":require("@/assets/whiteAsset.svg")}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }